import {
  fork,
  call,
  put,
  all,
  takeEvery,
  takeLatest,
  takeLeading
} from "redux-saga/effects";
import asyncInterface from "../../../../asyncInterface";
import { grant } from "../../../../services/apiServices";
import * as actionTypes from "./actionTypes";
import { getGrantDetailsType } from "../GrantsActivity/actionTypes";

/**
 * RG is short for RECOMMEND GRANT
 * used in actions types to make it unique
 * */

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendGrant.fetchAccountData(fetchPayload);
}

export function postCharityData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendGrant.postCharityData(fetchPayload.payload);
}

export function* postSearchCharityDataWorker(fetchPayload) {
  try {
    const response = yield call(postCharityData, fetchPayload);
    const serverDown = response.data === "The system is temporarily unavailable";
    if (typeof response.data === "string") {
      yield put({ type: actionTypes.searchCharityResponseType, payload: { hits: [], serverDown } });
    }
    yield put({ type: actionTypes.searchCharityResponseType, payload: { ...response.data.data, serverDown } });
    yield put({
      type: actionTypes.searchCharityDataLengthType,
      payload: response.data.data.hits,
    });
  } catch (error) {
    yield put({ type: actionTypes.searchCharityErrorResponseType, payload: error });
  }
}

export function* fetchSearchGeminiDataWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    if (
      (typeof response.data === "string" && response.data.length === 0) ||
      typeof response.data.message === "string"
    ) {
      yield put({ type: actionTypes.searchGeminiResponseType, payload: [] });
    } else if (typeof response.data === "string" && response.data.length > 0) {
      yield put({ type: actionTypes.searchGeminiResponseType, payload: response.data });
    } else {
      yield put({ type: actionTypes.searchGeminiResponseType, payload: response.data });
    }
  } catch (error) {
    yield put({ type: actionTypes.searchGeminiErrorType, payload: error });
  }
}

export function* postSearchCityDataWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    yield put({ type: actionTypes.searchCityResponseType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.searchCityErrorType, payload: error });
  }
}

export function* postSearchCountyDataWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    yield put({ type: actionTypes.searchCountrySuccessResponseType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.searchCountryErrorResponseType, payload: error });
  }
}

export function* allocationDataWorker(fetchPayload) {
  yield put({
    type: actionTypes.fetchAllocationDataLoadingType,
  });
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    yield put({
      type: actionTypes.fetchAllocationDataSuccessType,
      payload: response,
    });
  } catch (error) {
    yield put({
      type: actionTypes.fetchAllocationDataFailType,
      error,
    });
  } finally {
    yield put({
      type: actionTypes.fetchAllocationDataDoneType,
    });
  }
}

export function* updateFromWorker(fetchPayload) {
  yield put({ type: actionTypes.updateFromCounterWorkerType, payload: fetchPayload });
}

export function* updateFromLoadMoreWorker(fetchPayload) {
  yield put({
    type: actionTypes.updateFromLoadMoreCounterWorkerType,
    payload: fetchPayload,
  });
}

export function* fetchRecentGrantWatcher() {
  yield takeEvery(actionTypes.fetchRecentGrantType, fetchRecentGrantWorker);
}

export function* fetchRecentGrantWorker(action) {
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({ type: actionTypes.fetchRecentGrantSuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.fetchRecentGrantFailType, error });
  }
}

export function* postSearchCharity() {
  yield takeEvery(actionTypes.postCharitySearchType, postSearchCharityDataWorker);
}

export function* fetchSearchGemini() {
  yield takeEvery(actionTypes.searchGeminiType, fetchSearchGeminiDataWorker);
}

export function* postSearchCity() {
  yield takeEvery(actionTypes.postCitySearchType, postSearchCityDataWorker);
}

export function* postSearchCounty() {
  yield takeEvery(actionTypes.postCountrySearchType, postSearchCountyDataWorker);
}

export function* updateFrom() {
  yield takeLatest(actionTypes.updateFromCounterType, updateFromWorker);
}
export function* updateLoadMoreFrom() {
  yield takeEvery(actionTypes.updateFromLoadingCounterType, updateFromLoadMoreWorker);
}

export function* allocationDataWatcher() {
  yield takeEvery(actionTypes.receiveAllocationDataType, allocationDataWorker);
}

export function* fetchGrantHistory() {
  yield takeLatest(actionTypes.fetchGrantHistoryType, grantHistoryWorker);
}

export function* grantHistoryWorker(action) {
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({ type: actionTypes.fetchGrantHistorySuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.fetchGrantHistoryFailType, error });
  }
}

export function* fetchPendingGrant() {
  yield takeLatest(actionTypes.fetchPendingGrantType, pendingGrantWorker);
}

/** Getting from Grant Activity */
export function* fetchGrantDetails() {
  yield takeLatest(getGrantDetailsType, grantDetailsWorker);
}

export function* cancelGrantScheduleWatcher() {
  yield takeLatest(actionTypes.cancelScheduleType, cancelGrantSchedule);
}

export function* cancelGrantSchedule(action) {
  try {
    const response = yield call(
      grant.cancelPendingSpawnPayment,
      action.payload
    );
    yield put({
      type: actionTypes.cancelScheduleSuccessType,
      payload: response.data ? action.payload.pendingSpawnId : "NA",
    });
    action.payload.successFn && action.payload.successFn();
  } catch (error) {
    yield put({ type: actionTypes.cancelScheduleFailType, error });
    action.payload.failureFn && action.payload.failureFn();
  }
}

export function* cancelAllSchedulesWatcher() {
  yield takeLatest(actionTypes.cancelAllSchedulesType, cancelAllSchedules);
}

export function* cancelAllSchedules(action) {
  try {
    const response = yield call(grant.cancelGrant, action.payload);
    yield put({
      type: actionTypes.cancelAllScheduleSuccessType,
      payload: response.data,
    });
    action.payload.successFn && action.payload.successFn();
  } catch (error) {
    yield put({ type: actionTypes.cancelAllScheduleFailType, error });
    action.payload.failureFn && action.payload.failureFn();
  }
}

export function* updateSpawnWatcher() {
  yield takeLeading(actionTypes.updateIndividualSpawnType, updateSpawnWorker);
}

export function* updateSpawnWorker(action) {
  try {
    const response = yield call(grant.updateIndividualSpawn, action.payload);
    action.payload.onSuccess();
  } catch (error) {
    yield put({ type: actionTypes.updateGrantFailType, payload: [error] });
  }
}

export function* addSpawnWatcher() {
  yield takeLatest(actionTypes.addSpawnType, addSpawnWorker);
}

export function* addSpawnWorker(action) {
  try {
    const response = yield call(
      grant.addAnotherPaymentForSchedule,
      action.payload
    );
    yield put({ type: actionTypes.addSpawnSuccessType, payload: response.data });
    action.payload.successFn && action.payload.successFn();
  } catch (error) {
    action.payload.failureFn && action.payload.failureFn();
    yield put({ type: actionTypes.addSpawnFailType, error });
  }
}

export function* grantDetailsWorker(action) {
  try {
    let grantApi;
    if (action.payload.grantId)
      grantApi = grant.findGrantDetailsByAccountIdAndGrantId;
    else if (action.payload.spawnId)
      grantApi = grant.getSpawnBySpawnIdAndScheduleId;
    else grantApi = grant.findRecurringGrantByScheduleId;
    const response = yield call(grantApi, action.payload);
    if (action.payload.spawnId) {
      response.data.pendingSpawnId = action.payload.spawnId;
    }
    yield put({ type: actionTypes.fetchGrantDetailSuccessType, payload: response.data });
    action.payload.successFn && action.payload.successFn();
  } catch (error) {
    action.payload.failureFn && action.payload.failureFn();
    yield put({ type: actionTypes.fetchGrantDetailFalType, error });
  }
}

export function* pendingGrantWorker(action) {
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({ type: actionTypes.fetchPendingGrantSuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.fetchPendingGrantFailType, error });
  }
}

export function* getGrantPurposeConfig() {
  yield takeLatest(actionTypes.fetchGrantPurposeType, getGrantPurposeConfigWorker);
}

export function* getGrantPurposeConfigWorker(action) {
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({ type: actionTypes.fetchGrantPurposeSuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.fetchGrantPurposeFailType, payload: error });
  }
}

export function* removeCharityWatcher() {
  yield takeEvery(actionTypes.removeCharityType, removeCharityWorker);
}

export function* removeCharityWorker(fetchPayload) {
  try {
    const response = yield call(postCharityData, fetchPayload);
    yield put({ type: actionTypes.removeCharitySuccessType, payload: fetchPayload });
    if (fetchPayload.successFn) {
      fetchPayload.successFn();
    }
  } catch (error) {
    yield put({ type: actionTypes.removeCharityFailType, payload: error });
  }
}

export function* fetchSavedCharityWatcher() {
  yield takeLatest(actionTypes.fetchSavedCharityType, fetchSavedCharityWorker);
}

export function* fetchSavedCharityWorker(action) {
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({ type: actionTypes.fetchSavedCharitySuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.fetchSavedCharityFailType, error });
  }
}

export function* submitGrantWatcher() {
  yield takeLatest(actionTypes.submitGrantType, submitGrantWorker);
}

export function* submitGrantWorker(action) {
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({ type: actionTypes.submitGrantSuccessType, payload: response.data });
    action.successFn && action.successFn(response.data);
  } catch (error) {
    yield put({ type: actionTypes.submitGrantFailType, payload: error });
  }
}

export function* updateGrantWatcher() {
  yield takeLatest(actionTypes.updateGrantType, updateGrantWorker);
}

export function* updateGrantWorker(action) {
  try {
    const { updatedGrant, updateType, ...restKeys} = action.payload;

    let updateAPI;
    if(updateType === "recurringGrant"){
      updateAPI = grant.updateRecurringGrantPurposeEdit;
    }
    else if (updatedGrant.grantType === "multipleTime") {
      updateAPI = grant.updateRecurringGrant;
    } else {
      if (updatedGrant.pendingSpawnId) {
        updateAPI = grant.udpatePendingSpawn;
      } else {
        updateAPI = grant.updateSingleGrant;
      }
    }
    const response = yield call(updateAPI, {updatedGrant, ...restKeys});
    const { error, errors } = response.data;

    if (!error && !(errors && errors.length)) {
      yield put({ type: actionTypes.updateGrantSuccessType, payload: response.data });
      action.successFn && action.successFn(response.data);
    } else {
      yield put({
        type: actionTypes.updateGrantFailType,
        payload: error && !errors ? [error] : errors,
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.updateGrantFailType, payload: [error] });
  }
}

export function* submitSavedDataWatcher() {
  yield takeEvery(actionTypes.saveCharityType, submitSavedDataWorker);
}

export function* submitSavedDataWorker(action) {
  try {
    const response = yield call(grant.suggestCharity, action.payload);
    const { charityData } = action.payload;
    yield put({
      type: actionTypes.saveCharitySuccessType,
      payload: response.data,
      prevData: charityData,
    });
    if (action.successFn) {
      action.successFn(response.data);
    }
  } catch (error) {
    const { charityData } = action.payload;
    yield put({
      type: actionTypes.saveCharityFailType,
      payload: error,
      prevData: charityData,
    });
  }
}

export function* addCharityWatcher() {
  yield takeEvery(actionTypes.addCharityType, addCharityWorker);
}

export function* addCharityWorker(action) {
  try {
    const response = yield call(grant.addCharity, action.payload);
    const charityData = action.selectedCharity;
    yield put({
      type: actionTypes.addCharitySuccessType,
      payload: response.data,
      prevData: charityData,
    });
    if (action.successFn) {
      action.successFn(response.data);
    }
  } catch (error) {
    const charityData = action.selectedCharity;
    yield put({
      type: actionTypes.addCharityFailType,
      payload: error,
      prevData: charityData,
    });
  }
}

export function* submitSavedGeminiDataWatcher() {
  yield takeEvery(actionTypes.postGeminiSavedDataType, submitSavedGeminiDataWorker);
}

export function* submitSavedGeminiDataWorker(action) {
  try {
    const response = yield call(grant.addCharity, action.payload);
    const { charityData } = action.payload;
    yield put({
      type: actionTypes.submitSavedGeminiDataSuccessType,
      payload: response.data,
      prevData: charityData,
    });
    if (action.successFn) {
      action.successFn(response.data);
    }
  } catch (error) {
    const { charityData } = action.payload;
    yield put({
      type: actionTypes.submitSavedGeminiDataFailType,
      payload: error,
      prevData: charityData,
    });
  }
}

export function* fetchPoolsPendingAdminFeeWatcher() {
  yield takeEvery(actionTypes.poolsPendingAdminFeeType, fetchPoolsPendingAdminFeeWorker);
}

export function* fetchPoolsPendingAdminFeeWorker(action) {
  try {
    const ppcResponse = yield call(
      grant.getPoolsPendingContribution,
      action.payload
    );
    const poolsPendingContrib =
      ppcResponse.data &&
      ppcResponse.data.map((pool) => ({
        id: pool.poolId,
        name: pool.poolFullName,
      }));
    yield put({
      type: actionTypes.fetchPoolsPendingContributionSuccessType,
      payload: poolsPendingContrib,
    });
    const adminFeeResponse = yield call(grant.getAdminFee, action.payload);
    yield put({
      type: actionTypes.fetchAdminFeeSuccessType,
      payload: adminFeeResponse.data,
    });
    yield put({ type: actionTypes.fetchPoolsPendingAdminFeeSuccessType });
    action.successFn &&
      action.successFn(poolsPendingContrib, adminFeeResponse.data);
  } catch (error) {
    yield put({ type: actionTypes.fetchPoolsPendingAdminFeeFailType, payload: error });
  }
}

export default function* RecommendGrant() {
  yield all([
    fork(fetchRecentGrantWatcher),
    fork(getGrantPurposeConfig),
    fork(postSearchCharity),
    fork(postSearchCity),
    fork(postSearchCounty),
    fork(updateFrom),
    fork(fetchSearchGemini),
    fork(updateLoadMoreFrom),
    fork(allocationDataWatcher),
    fork(fetchGrantHistory),
    fork(fetchPendingGrant),
    fork(fetchGrantDetails),
    fork(removeCharityWatcher),
    fork(fetchSavedCharityWatcher),
    fork(submitGrantWatcher),
    fork(updateGrantWatcher),
    fork(submitSavedDataWatcher),
    fork(submitSavedGeminiDataWatcher),
    fork(cancelAllSchedulesWatcher),
    fork(cancelGrantScheduleWatcher),
    fork(addSpawnWatcher),
    fork(updateSpawnWatcher),
    fork(fetchPoolsPendingAdminFeeWatcher),
    fork(addCharityWatcher),
  ]);
}
